import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { forwardRef } from 'react';
import TextLink from 'components/TextLink';
import Icon from 'components/Icon';
import Flex from 'components/Flex';
var MenuTextButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(TextLink, _extends({}, otherProps, {
    as: "button",
    ref: ref,
    bold: true
  }), /*#__PURE__*/React.createElement(Flex, {
    align: "center"
  }, children, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron"
  })));
});
MenuTextButton.displayName = 'MenuTextButton';
export default MenuTextButton;